export const EMPLOYEE_DEPARTMENTS = {
  SALES: 'Sales',
  CLIENT_SERVICES: 'Client Services',
  KNOWLEDGE_MANAGEMENT: "Knowledge Management"
}

export const CLIENT_DEPARTMENTS = {
  CLIENT: 'Client'
}